

import kollegenauslieferungSearchData from '@/shared/model/smallPayloadModels/kollegenauslieferungSearchData';
import { TblKollegenauslieferungState } from './types';

export const state = (): TblKollegenauslieferungState => initialState();

export const initialState = (): TblKollegenauslieferungState => ({
  kollegenauslieferungSearchData: kollegenauslieferungSearchData.defaultData(),
  tblKollegenauslieferungs: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['zr_number'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
      andClauseFieldsIds: [],
    },
  },
});
